import ROP from '@gdyfe/rop-client'
import { ENV_CONFIG } from '@/config';

const rp = new ROP({
  ICS_ADDR: `mqttdms.${ENV_CONFIG.ROP_DOMAIN}`,
  ROP_FLASH_SITE: `https://cdn.${ENV_CONFIG.ROP_DOMAIN}/dms/`
})

export default rp
